/* ==========================================================================
   8TrackFit - Spin & Win

   The wheel base is a photoreal iron-plate <img> inside the rotor div; this
   script paints the prize sectors OVER the photo in the overlay SVG at exact
   360/n spacing, so the weighted landing math stays precise no matter what
   the photo looks like. Sector geometry is tuned to the plate render: the
   silver rim ends at ~r140 and the hub collar at ~r38 (viewBox units, 360
   wide) - keep R_OUT/R_IN inside that band if the photo changes.

   SECTOR COUNT IS DYNAMIC (2026-09-17): sections/tf-spin-wheel.liquid emits
   only the prizes whose chance is above 0, so the face can be 6 slices, or 2,
   or six copies of a single prize. Everything angular derives from SEG =
   360 / segments.length - do not hard-code 60 again.

   Every segment maps to a REAL active discount code (see the section). The
   winning code is written to localStorage as a reservation; tf-offer.js owns
   applying it to the cart and merging it with the other offers, plus the
   countdown in the drawer strip.

   Gating:
     sessionStorage tf_spin_seen - popup shows once per browsing session
     localStorage  tf_spin_done  - one spin per customer, forever
     localStorage  tf_spin       - the active reservation {code,kind,pct,prize,until}

   The outcome is WEIGHTED (weights = the chances set in the theme editor) -
   the animation then rotates to land exactly on the chosen face.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('tf-spin');
  if (!root) return;

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    ses: function (k, v) {
      try {
        if (v === undefined) return sessionStorage.getItem(k);
        sessionStorage.setItem(k, v);
      } catch (e) { return null; }
    }
  };

  /* one spin per customer - never resurface after a win */
  if (store.get('tf_spin_done') === '1') return;

  var segments = [];
  try { segments = JSON.parse(root.querySelector('[data-tf-spin-segments]').textContent); } catch (e) { return; }
  if (!segments.length) return;

  var SEG = 360 / segments.length; /* degrees per face */

  var els = {
    rotor: root.querySelector('[data-tf-spin-rotor]'),
    plate: root.querySelector('.tf-spin__plate'),
    faces: root.querySelector('[data-tf-spin-faces]'),
    rivets: root.querySelector('[data-tf-spin-rivets]'),
    gate: root.querySelector('[data-tf-spin-gate]'),
    email: root.querySelector('[data-tf-spin-email]'),
    unlock: root.querySelector('[data-tf-spin-unlock]'),
    error: root.querySelector('[data-tf-spin-error]'),
    action: root.querySelector('[data-tf-spin-action]'),
    go: root.querySelector('[data-tf-spin-go]'),
    result: root.querySelector('[data-tf-spin-result]'),
    wonline: root.querySelector('[data-tf-spin-wonline]'),
    holdline: root.querySelector('[data-tf-spin-holdline]'),
    sub: root.querySelector('[data-tf-spin-sub]')
  };

  /* ---------- paint the faces over the plate photo ---------- */

  var NS = 'http://www.w3.org/2000/svg';
  var CX = 180, CY = 180, R_OUT = 137, R_IN = 58;

  function polar(r, deg) {
    var a = (deg - 90) * Math.PI / 180;
    return [CX + r * Math.cos(a), CY + r * Math.sin(a)];
  }

  function facePath(i) {
    var a0 = i * SEG - SEG / 2, a1 = i * SEG + SEG / 2;
    var large = SEG > 180 ? 1 : 0;
    var p1 = polar(R_OUT, a0), p2 = polar(R_OUT, a1);
    var p3 = polar(R_IN, a1), p4 = polar(R_IN, a0);
    return 'M' + p1[0] + ' ' + p1[1] +
      ' A' + R_OUT + ' ' + R_OUT + ' 0 ' + large + ' 1 ' + p2[0] + ' ' + p2[1] +
      ' L' + p3[0] + ' ' + p3[1] +
      ' A' + R_IN + ' ' + R_IN + ' 0 ' + large + ' 0 ' + p4[0] + ' ' + p4[1] + ' Z';
  }

  var ICONS = {
    truck: '<g fill="none" stroke="COL" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="-9" y="-7" width="11" height="10" rx="1"/><path d="M2 -4h4l3 4v3H2z"/><circle cx="-4.5" cy="5" r="2"/><circle cx="5" cy="5" r="2"/></g>',
    pct: '<g fill="none" stroke="COL" stroke-width="2" stroke-linecap="round"><circle cx="0" cy="0" r="9"/><line x1="-4" y1="4" x2="4" y2="-4"/><circle cx="-3.5" cy="-3.5" r="1.4" fill="COL"/><circle cx="3.5" cy="3.5" r="1.4" fill="COL"/></g>',
    gift: '<g fill="none" stroke="COL" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="-8" y="-3" width="16" height="11" rx="1"/><line x1="0" y1="-3" x2="0" y2="8"/><path d="M-8 -3h16M0 -3c-5 0-7-2-7-4a2.6 2.6 0 0 1 5-1c1 1 2 3 2 5 0-2 1-4 2-5a2.6 2.6 0 0 1 5 1c0 2-2 4-7 4"/></g>',
    bag: '<g fill="none" stroke="COL" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M-8 -3h16l-1.5 12h-13z"/><path d="M-4 -3a4 4 0 0 1 8 0"/></g>'
  };

  segments.forEach(function (seg, i) {
    var dark = i % 2 === 1; /* odd faces stay raw iron, even faces get cream paint */
    var inkCol = dark ? '#efe9db' : '#141414';
    var iconCol = dark ? '#e8e2d4' : '#aa1314';

    var g = document.createElementNS(NS, 'g');

    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', facePath(i));
    path.setAttribute('fill', dark ? '#000000' : '#f2eee5');
    path.setAttribute('fill-opacity', dark ? '0.30' : '0.92');
    path.setAttribute('stroke', 'rgba(0,0,0,0.5)');
    path.setAttribute('stroke-width', '1');
    g.appendChild(path);

    /* machined highlight on the leading edge of every face */
    var a0 = i * SEG - SEG / 2;
    var s1 = polar(R_IN, a0), s2 = polar(R_OUT, a0);
    var sep = document.createElementNS(NS, 'line');
    sep.setAttribute('x1', s1[0]); sep.setAttribute('y1', s1[1]);
    sep.setAttribute('x2', s2[0]); sep.setAttribute('y2', s2[1]);
    sep.setAttribute('stroke', 'rgba(255,255,255,0.12)');
    sep.setAttribute('stroke-width', '0.8');
    g.appendChild(sep);

    var content = document.createElementNS(NS, 'g');
    content.setAttribute('transform', 'rotate(' + (i * SEG) + ' ' + CX + ' ' + CY + ')');

    var icon = document.createElementNS(NS, 'g');
    icon.setAttribute('transform', 'translate(' + CX + ' ' + (CY - 108) + ')');
    icon.innerHTML = (ICONS[seg.icon] || ICONS.gift).split('COL').join(iconCol);
    content.appendChild(icon);

    var lines = String(seg.label || '').split('\n');
    lines.forEach(function (ln, li) {
      var t = document.createElementNS(NS, 'text');
      t.setAttribute('x', CX);
      t.setAttribute('y', CY - 88 + li * 12.5);
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('font-family', 'Arial, sans-serif');
      t.setAttribute('font-size', '11');
      t.setAttribute('font-weight', '800');
      t.setAttribute('letter-spacing', '0.8');
      t.setAttribute('fill', inkCol);
      t.textContent = ln.toUpperCase();
      content.appendChild(t);
    });

    g.appendChild(content);
    els.faces.appendChild(g);

    /* steel rivet on the joint (fill/stroke inherited from the group) */
    var rv = document.createElementNS(NS, 'circle');
    var rp = polar(R_OUT + 7, i * SEG + SEG / 2);
    rv.setAttribute('cx', rp[0]); rv.setAttribute('cy', rp[1]); rv.setAttribute('r', '3.6');
    els.rivets.appendChild(rv);
  });

  /* ---------- open / close ---------- */

  var minutes = parseFloat(root.dataset.reserveMinutes) || 15;
  var delay = (parseFloat(root.dataset.delay) || 5) * 1000;

  function open() {
    root.hidden = false;
    /* decode the plate BEFORE anything animates - a first-frame decode of a
       760px JPEG is exactly the kind of hitch that makes the spin stutter */
    if (els.plate && els.plate.decode) els.plate.decode().catch(function () {});
    var reveal = function () { root.dataset.open = 'true'; };
    requestAnimationFrame(function () { requestAnimationFrame(reveal); });
    setTimeout(reveal, 80);
  }

  function close() {
    root.dataset.open = 'false';
    setTimeout(function () { root.hidden = true; }, 380);
  }

  root.querySelector('[data-tf-spin-close]').addEventListener('click', close);
  root.querySelector('[data-tf-spin-close-overlay]').addEventListener('click', function () {
    if (!spinning) close();
  });

  if (store.ses('tf_spin_seen') !== '1') {
    setTimeout(function () {
      store.ses('tf_spin_seen', '1');
      open();
    }, delay);
  }

  /* ---------- email gate ---------- */

  var unlocked = false;

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  els.unlock.addEventListener('click', function () {
    var v = (els.email.value || '').trim();
    if (!validEmail(v)) { els.error.hidden = false; els.email.focus(); return; }
    els.error.hidden = true;
    unlocked = true;

    /* real capture: the native storefront customer form endpoint - creates a
       customer with marketing consent, visible in Shopify admin */
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', v);
    body.append('contact[tags]', 'spin-wheel');
    fetch('/contact', { method: 'POST', credentials: 'same-origin', body: body }).catch(function () {});

    els.gate.hidden = true;
    els.action.hidden = false;
    if (els.sub) els.sub.textContent = 'You are in - give it a spin!';
  });

  els.email.addEventListener('keydown', function (e) { if (e.key === 'Enter') els.unlock.click(); });

  /* ---------- the spin ---------- */

  var spinning = false;

  function weightedPick() {
    var total = segments.reduce(function (s, x) { return s + (x.weight || 0); }, 0);
    if (total <= 0) return 0;
    var roll = Math.random() * total;
    for (var i = 0; i < segments.length; i++) {
      roll -= (segments[i].weight || 0);
      if (roll <= 0) return i;
    }
    return segments.length - 1;
  }

  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }

  els.go.addEventListener('click', function () {
    if (spinning || !unlocked) return;
    spinning = true;
    els.go.disabled = true;
    els.go.textContent = 'Spinning...';

    var idx = weightedPick();
    var seg = segments[idx];

    /* land the chosen face under the top pointer: 5 full turns plus the
       face's negative offset, with a little in-face jitter for realism
       (kept inside the face, so it scales with the sector angle).
       The start is deferred one frame so the browser can promote the rotor
       to its own layer before the transition begins (no first-frame skip). */
    var jitter = (Math.random() * SEG * 0.6) - (SEG * 0.3);
    var target = 5 * 360 - (idx * SEG) + jitter;
    var launch = function () { els.rotor.style.transform = 'rotate(' + target + 'deg)'; };
    requestAnimationFrame(function () { requestAnimationFrame(launch); });
    setTimeout(launch, 60);

    var finish = function () {
      var until = Date.now() + minutes * 60 * 1000;
      store.set('tf_spin', JSON.stringify({ code: seg.code, kind: seg.kind, pct: seg.pct || 0, prize: seg.prize, until: until }));
      store.set('tf_spin_done', '1');

      els.action.hidden = true;
      els.result.hidden = false;
      els.wonline.innerHTML = '🎉 You won <strong>' + seg.prize + '</strong>!';
      if (els.sub) els.sub.textContent = 'Nice spin!';

      var tickHold = function () {
        var left = until - Date.now();
        if (left <= 0) {
          els.holdline.textContent = 'Your reservation window has closed - but we saved your email, so keep an eye out for more treats.';
          return;
        }
        els.holdline.innerHTML = "We've tucked it into your cart and it's reserved for you for <b>" + fmt(left) + '</b> - check out before the timer runs out and it’s all yours. 💛';
        setTimeout(tickHold, 1000);
      };
      tickHold();

      /* hand the code to the offer engine - it applies it to the cart,
         merges with any running offers, and shows the drawer countdown */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: {}, sourceId: 'tf-spin', data: { source: 'tf-spin', itemCount: 0 } }
      }));
    };

    var done = false;
    var onEnd = function () { if (done) return; done = true; finish(); };
    els.rotor.addEventListener('transitionend', onEnd, { once: true });
    /* transitionend never fires in hidden/battery-saver tabs - back it up
       (spin transition is 5.2s in tf-spin.css; keep this above it) */
    setTimeout(onEnd, 5900);
  });
})();
